export default "__VITE_ASSET__JinUUCVJ__"